var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.143a7.5 7.5 0 117.5-7.5 7.508 7.508 0 01-7.5 7.5zm0-14.063a6.563 6.563 0 100 13.125 6.563 6.563 0 000-13.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.502 10.143a.535.535 0 01-.334-.117L7.167 8.404A.428.428 0 017 8.073V4.59c0-.16.095-.307.25-.387a.552.552 0 01.5 0c.155.08.25.227.25.387v3.29l1.835 1.492a.43.43 0 01.164.31.42.42 0 01-.129.322.531.531 0 01-.368.139z"
  }))));
}
export default SvgTime;